<template>
  <div class="property-index-container">
    <div class="vc-index-nav">
      <span><i class="el-icon-s-home margin-right-sm"></i>{{ $t('propertyIndex.home') }}</span>
      <span class="margin-left-sm margin-right-sm">/</span>
      <span>{{ $t('propertyIndex.dashboard') }}</span>
    </div>

    <el-row class="vc-index-1" :gutter="20">
      <el-col :xs="24" :sm="24" :md="15">
        <index-community ref="indexCommunity" />
      </el-col>
      <el-col :xs="24" :sm="24" :md="9">
        <index-notice ref="indexNotice" />
      </el-col>
    </el-row>

    <el-row class="vc-index-1" :gutter="20">
      <el-col :xs="24" :sm="24" :md="15">
        <index-repair-complaint ref="indexRepairComplaint" />
      </el-col>
      <el-col :xs="24" :sm="24" :md="9">
        <index-owner-room ref="indexOwnerRoom" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import IndexCommunity from '@/components/index/indexCommunity'
import IndexNotice from '@/components/index/indexNotice'
import IndexRepairComplaint from '@/components/index/indexRepairComplaint'
import IndexOwnerRoom from '@/components/index/indexOwnerRoom'

export default {
  name: 'PropertyIndexList',
  components: {
    IndexCommunity,
    IndexNotice,
    IndexRepairComplaint,
    IndexOwnerRoom
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      this.$refs.indexCommunity._loadPropertyIndexAssets()
      this.$refs.indexNotice._loadPropertyIndexNotices()
      this.$refs.indexRepairComplaint.initData()
      this.$refs.indexOwnerRoom._loadIndexOwnerRegisterData()
    }
  }
}
</script>

<style lang="scss" scoped>
.ds-property-index-container {
  padding: 0 var(--ds-spacing-lg);
  background: var(--ds-gray-100);
  min-height: calc(100vh - 60px);

  .vc-index-nav {
    padding: var(--ds-spacing-md);
    font-size: var(--ds-font-size-lg);
    text-align: left;
    color: var(--ds-gray-700);
    font-weight: 500;
    display: flex;
    align-items: center;

    i {
      color: var(--ds-primary);
      margin-right: var(--ds-spacing-sm);
    }
  }

  .vc-index-1 {
    margin-bottom: var(--ds-spacing-lg);

    .index-1-left,
    .index-1-right {
      height: 100%;
    }
  }
}

.margin-right-sm {
  margin-right: var(--ds-spacing-sm);
}

.margin-left-sm {
  margin-left: var(--ds-spacing-sm);
}

.margin-top-lg {
  margin-top: var(--ds-spacing-lg);
}

.margin-bottom {
  margin-bottom: var(--ds-spacing-lg);
}

.vc-index-1 {
  margin-bottom: var(--ds-spacing-lg);
}

.property-index-container {
  padding: 0 10px;
}
</style>